const DATE_TIME_FORMAT: Intl.DateTimeFormatOptions = {
	year: "numeric",
	month: "short",
	day: "numeric",
	hour: "2-digit",
	minute: "2-digit",
};

// Format the fiat invoice amount with its currency code (e.g. "$205.00",
// "€205.00"). Falls back to "<amount> <currency>" for non-ISO codes.
export const formatFiat = (value?: string, currency?: string): string => {
	if (!value) {
		return "—";
	}

	const amount = Number(value);
	if (!Number.isFinite(amount) || !currency) {
		return currency ? `${value} ${currency}` : value;
	}

	try {
		return amount.toLocaleString("en-US", {
			style: "currency",
			currency,
		});
	} catch {
		return `${value} ${currency}`;
	}
};

// Format a USD-denominated string as currency (e.g. "$10.00"). Returns null
// when there is no meaningful value to show.
export const formatUsd = (value?: string): string | null => {
	if (!value) {
		return null;
	}

	const amount = Number(value);
	if (!Number.isFinite(amount) || amount === 0) {
		return null;
	}

	return amount.toLocaleString("en-US", {
		style: "currency",
		currency: "USD",
	});
};

export const formatDateTime = (dateStr?: string): string => {
	if (!dateStr) {
		return "—";
	}

	const date = new Date(dateStr);
	if (Number.isNaN(date.getTime())) {
		return dateStr;
	}

	return date.toLocaleDateString("en-US", DATE_TIME_FORMAT);
};
